var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrammar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "#818181",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 0H20.7432V17H22.0002V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1288 0H17.9277V17H19.1288V0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4637 0H15.2627V17H16.4637V0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.71 16.9994V15.762L0.000801086 15.762V16.9994L18.71 16.9994Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000134587 16.9999H1.20117L1.20117 11.5769H0.000134587L0.000134587 16.9999Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06263 16.9999H5.26367L5.26367 11.5769H4.06263L4.06263 16.9999Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45521 16.8146H7.65625L7.65625 11.5772H6.45521L6.45521 16.8146Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26367 12.8139V11.5765L0.000126362 11.5765V12.8139H5.26367Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 12.8147V11.5772L6.45526 11.5772V12.8147L11.998 12.8147Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0088 10.5711V9.33366H8.6326V10.5711H10.0088Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 10.5716V9.33417H2.89041V10.5716H4.2666Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20215 10.5711V9.33366H0.82596L0.82596 10.5711H2.20215Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrammar);
export default __webpack_public_path__ + "static/media/Grammar.90a8683915308ab023515e997821bc92.svg";
export { ForwardRef as ReactComponent };